<template>
  <div class="register">
    <div class="register-box">
      <div class="register-logo" v-if="site">
        <img :src="site.pcWebsiteLogo ? site.pcWebsiteLogo : '../assets/pic/login-logo.png'" width="185" />
      </div>
      <div class="form">
        <el-form :model="form" ref="form" class="form" v-if="step === 1">
          <div class="register-form">
            <div class="email">
              <el-form-item prop="username" :rules="[{ validator: checkUsername, trigger: 'blur' }]">
                <el-input v-model="form.username" :placeholder="ts('Enter an email address for your account')['Enter an email address for your account']"></el-input>
              </el-form-item>
            </div>
            <div class="code">
              <el-form-item prop="smscode" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                <el-input v-model="form.smscode" :placeholder="ts('Verification Code')['Verification Code']" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <el-button class="btn-code" :disabled="state.smsSendBtn" @click="getCaptcha">{{ (!state.smsSendBtn && ts('Get Verification Code')['Get Verification Code']) || state.time + ' s' }}</el-button>
          </div>
          <div class="register-submit">
            <el-button type="primary" class="btn btn-theme" @click="nextStep('form')" :loading="btnLoading">{{ ts('Next')['Next'] }}</el-button>
          </div>
          <router-link class="to-login" to="/login">{{ ts('Login with an existing account')['Login with an existing account'] }}</router-link>
        </el-form>
        <el-form :model="form" ref="form" class="form" v-else-if="step === 2">
          <div class="register-form">
            <div class="password">
              <el-form-item prop="password" :rules="[{ validator: validatePass, trigger: 'blur' }]">
                <el-input type="password" v-model="form.password" :placeholder="ts('Create a password for your account')['Create a password for your account']" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <div class="password">
              <el-form-item prop="checkPass" :rules="[{ validator: validatePass2, trigger: 'blur' }]">
                <el-input type="password" v-model="form.checkPass" :placeholder="ts('Confirm password')['Confirm password']" autocomplete="off"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="register-submit">
            <el-button type="primary" class="btn btn-theme" @click="submitForm('form')" :loading="btnLoading">{{ ts('Submit')['Submit'] }}</el-button>
          </div>
          <router-link class="to-login" to="/login">{{ ts('Login with an existing account')['Login with an existing account'] }}</router-link>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import { mapState } from 'vuex'

export default {
  name: 'ForgotPassword',
  mixins: [LanguagePackage],
  data() {
    return {
      step: 1,
      form: {
        username: '',
        password: '',
        checkPass: '',
        smscode: '',
      },
      state: {
        time: 60,
        smsSendBtn: false,
      },
      btnLoading: false,
    }
  },
  computed: {
    ...mapState(['site']),
  },
  methods: {
    checkUsername(rule, value, callback) {
      let reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/
      if (!reg.test(value)) {
        callback(new Error(this.translate('請輸入正確的郵箱地址')))
      }

      if (!value) {
        callback(new Error(this.translate('请输入邮箱')))
      } else {
        callback()
      }
    },
    validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error(this.translate('请输入密码')))
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    },
    validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error(this.translate('请再次输入密码')))
      } else if (value !== this.form.password) {
        callback(new Error(this.translate('两次输入密码不一致!')))
      } else {
        callback()
      }
    },

    getCaptcha() {
      let that = this
      this.$refs.form.validateField('username', (err) => {
        if (!err) {
          this.state.smsSendBtn = true
          let interval = window.setInterval(() => {
            if (that.state.time-- <= 0) {
              that.state.time = 60
              that.state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)
          // const hide = this.$message.loading('验证码发送中..', 0)
          postAction(`/sys/sms`, {
            username: this.form.username,
            smsmode: 2,
          })
            .then((res) => {
              this.$message({
                message: this.translate('验证码已发送'),
                type: 'success',
              })
            })
            .catch((err) => {
              clearInterval(interval)
              that.state.time = 60
              that.state.smsSendBtn = false
            })
        }
      })
    },

    // 第一步
    nextStep(formName) {
      this.$refs[formName].validate((valid) => {
        this.btnLoading = true
        if (valid) {
          let params = { ...this.form }
          postAction(`/sys/user/phoneVerification`, params).then((res) => {
            if (!res.success) {
              console.log(res.message)
            } else {
              this.step = 2
            }
            this.btnLoading = false
          })
        } else {
          this.btnLoading = false
          return false
        }
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        this.btnLoading = true
        if (valid) {
          let params = { ...this.form }
          delete params.checkPass
          getAction(`/sys/user/passwordChange`, params).then((res) => {
            if (!res.success) {
              console.log(res.message)
            } else {
              this.$router.push('/login')
            }
            this.btnLoading = false
          })
        } else {
          this.btnLoading = false
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style scoped lang="scss">
.register {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
.register-box {
  width: 500px;
  padding: 40px 70px;
  background: #fff;
  border-radius: 10px;
}
.register-logo {
  margin-bottom: 20px;
  text-align: center;
}

.btn-code {
  width: 100%;
  height: 40px;
  padding: 0;
  line-height: 38px;
  font-size: 16px;
  border: 1px solid #dcdfe6;
  text-align: center;
  border-radius: 4px;
}

.register-submit {
  margin-top: 20px;
  text-align: center;
  .btn {
    min-width: 140px;
  }
}

.to-login {
  display: block;
  margin-top: 10px;
  color: #29cf0f;
  text-align: center;
  cursor: pointer;
}
</style>
